const INTERCEPTOR_FIELD_PATTERN = /данные перехватчика/i;

export const filterInterceptorField = ({ NAME } = {}) =>
  !INTERCEPTOR_FIELD_PATTERN.test(NAME || "");

/**
 * Собирает extraData-функцию для interceptor-форм. Поле "Данные перехватчика"
 * ищется по имени (CODE в разных формах разный), значение — та же строка,
 * что и раньше: "Форма: <title>, <info>, Город: <city> Страница: <href>".
 */
export const buildInterceptorExtraData =
  ({ info, cityName }) =>
  ({ form }) => {
    const field = (form?.fields || []).find((f) =>
      INTERCEPTOR_FIELD_PATTERN.test(f?.NAME || ""),
    );
    if (!field?.CODE) {
      return {};
    }
    return {
      [field.CODE]: `Форма: ${form?.title || ""}, ${info}, Город: ${cityName} Страница: ${window.location.href}`,
    };
  };
